import React from 'react';

import app from '../../../../app.module.css';

const InitialAppointmentPONumberNotice = () => {
    return (
        <div className={app.warning}>
            Participant Record missing PO number, Initial Appointment cannot be marked as Attended
        </div>
    );
};

export default InitialAppointmentPONumberNotice;
